import { getAnalytics, logEvent } from 'firebase/analytics';

// Web error tracking, mirroring the mobile app's crash reporting: uncaught
// errors and unhandled promise rejections are reported as GA4 `exception`
// events (the web has no signed-in user, so Firestore writes are not an
// option under the current security rules). Deduped and capped per session
// so a render loop cannot flood analytics.

const maxReportsPerSession = 10;
const reportedSignatures = new Set();
let reportedCount = 0;
let isInstalled = false;

function reportError(description, fatal) {
  try {
    const signature = description.slice(0, 200);
    if (reportedCount >= maxReportsPerSession || reportedSignatures.has(signature)) {
      return;
    }
    reportedCount += 1;
    reportedSignatures.add(signature);

    logEvent(getAnalytics(), 'exception', {
      description: description.slice(0, 500),
      fatal,
      page_path: window.location.pathname,
    });
  } catch {
    // Analytics unavailable (blocked, not yet initialized) — never throw
    // from the error handler itself.
  }
}

export function describeError(error) {
  if (error instanceof Error) {
    return `${error.name}: ${error.message}\n${(error.stack ?? '').slice(0, 400)}`;
  }
  return String(error ?? 'Unknown error');
}

export function reportCaughtError(error, context) {
  reportError(`${context ? `[${context}] ` : ''}${describeError(error)}`, false);
}

export function installErrorTracking() {
  if (isInstalled) {
    return;
  }
  isInstalled = true;

  window.addEventListener('error', event => {
    reportError(describeError(event.error ?? event.message), true);
  });

  window.addEventListener('unhandledrejection', event => {
    reportError(`Unhandled rejection: ${describeError(event.reason)}`, false);
  });
}
